<template>
<div class="chapter">
<div class="inner_page">
<div class="chartsanddiagrams" id="chartsanddiagrams">
<h2 class="contentsHead1">CHARTS AND DIAGRAMS</h2>
<table class="table0">
<tbody><tr valign="top">
<td><a href="#/AttackonPearlHarbor_introduction1#cha1">1.</a></td>
<td> </td>
<td><a href="#/AttackonPearlHarbor_introduction1#cha1">Chart of Pearl Harbor, 7 December 1941</a></td>
</tr>
<tr valign="top">
<td></td></tr>
<tr valign="top">
<td><a href="#/AttackonPearlHarbor_ch101#cha2">2.</a></td>
<td> </td>
<td><a href="#/AttackonPearlHarbor_ch101#cha2">World Distribution of Battleships, 6 December 1941</a></td>
</tr>
<tr valign="top">
<td></td></tr>
<tr valign="top">
<td><a href="#/AttackonPearlHarbor_ch103#cha3">3.</a></td>
<td> </td>
<td><a href="#/AttackonPearlHarbor_ch103#cha3">World Distribution of Battleships, 1 January 1942</a></td>
</tr>
<tr valign="top">
<td></td></tr>
<tr valign="top">
<td><span href="#/AttackonPearlHarbor_ch201#cha4" title="Link target outside of Sample">4.</span></td>
<td> </td>
<td><span href="#/AttackonPearlHarbor_ch201#cha4" title="Link target outside of Sample">US Technical Mission to Japan Ordnance Data Page, 800-kg AP bomb</span></td>
</tr>
<tr valign="top">
<td></td></tr>
<tr valign="top">
<td><span href="#/AttackonPearlHarbor_ch203#cha5" title="Link target outside of Sample">5.</span></td>
<td> </td>
<td><span href="#/AttackonPearlHarbor_ch203#cha5" title="Link target outside of Sample">US Technical Mission to Japan Ordnance Data Page, 250-kg GP bomb</span></td>
</tr>
<tr valign="top">
<td></td></tr>
<tr valign="top">
<td><span href="#/AttackonPearlHarbor_ch401#cha6" title="Link target outside of Sample">6.</span></td>
<td> </td>
<td><span href="#/AttackonPearlHarbor_ch401#cha6" title="Link target outside of Sample">Torpedo Bomber Planned Attack Routes</span></td>
</tr>
<tr valign="top">
<td></td></tr>
<tr valign="top">
<td><span href="#/AttackonPearlHarbor_ch403#cha7" title="Link target outside of Sample">7.</span></td>
<td> </td>
<td><span href="#/AttackonPearlHarbor_ch403#cha7" title="Link target outside of Sample">AP Bombing Anticipated Results</span></td>
</tr>
<tr valign="top">
<td></td></tr>
<tr valign="top">
<td><span href="#/AttackonPearlHarbor_ch405#cha8" title="Link target outside of Sample">8.</span></td>
<td> </td>
<td><span href="#/AttackonPearlHarbor_ch405#cha8" title="Link target outside of Sample">Number of Inboard Battleships Crippled or Sunk</span></td>
</tr>
<tr valign="top">
<td></td></tr>
<tr valign="top">
<td><span href="#/AttackonPearlHarbor_ch407#cha9" title="Link target outside of Sample">9.</span></td>
<td> </td>
<td><span href="#/AttackonPearlHarbor_ch407#cha9" title="Link target outside of Sample">Japanese Aircraft Approach Routes</span></td>
</tr>
<tr valign="top">
<td></td></tr>
<tr valign="top">
<td><span href="#/AttackonPearlHarbor_ch701#cha10" title="Link target outside of Sample">10.</span></td>
<td> </td>
<td><span href="#/AttackonPearlHarbor_ch701#cha10" title="Link target outside of Sample">Timeline of Planned Torpedo Attacks on Carriers and Battleship Row</span></td>
</tr>
<tr valign="top">
<td><span href="#/AttackonPearlHarbor_ch702#cha11" title="Link target outside of Sample">11.</span></td>
<td> </td>
<td><span href="#/AttackonPearlHarbor_ch702#cha11" title="Link target outside of Sample">Actual Development of Torpedo Attacks on Carriers and Battleship Row</span></td>
</tr>
<tr valign="top">
<td></td></tr>
<tr valign="top">
<td><span href="#/AttackonPearlHarbor_ch704#cha12" title="Link target outside of Sample">12.</span></td>
<td> </td>
<td><span href="#/AttackonPearlHarbor_ch704#cha12" title="Link target outside of Sample">AP Bombing Under Actual and Expected Conditions</span></td>
</tr>
<tr valign="top">
<td></td></tr>
<tr valign="top">
<td><span href="#/AttackonPearlHarbor_ch706#cha13" title="Link target outside of Sample">13.</span></td>
<td> </td>
<td><span href="#/AttackonPearlHarbor_ch706#cha13" title="Link target outside of Sample">Distribution of Number of Inboard Battleships Sunk or Crippled</span></td>
</tr>
<tr valign="top">
<td></td></tr>
<tr valign="top">
<td><span href="#/AttackonPearlHarbor_ch708#cha14" title="Link target outside of Sample">14.</span></td>
<td> </td>
<td><span href="#/AttackonPearlHarbor_ch708#cha14" title="Link target outside of Sample">Submarine Patrol Areas</span></td>
</tr>
<tr valign="top">
<td></td></tr>
<tr valign="top">
<td><span href="#/AttackonPearlHarbor_ch801#cha15" title="Link target outside of Sample">15.</span></td>
<td> </td>
<td><span href="#/AttackonPearlHarbor_ch801#cha15" title="Link target outside of Sample">Torpedo Hits: Claimed and Actual</span></td>
</tr>
<tr valign="top">
<td></td></tr>
<tr valign="top">
<td><span href="#/AttackonPearlHarbor_ch803#cha16" title="Link target outside of Sample">16.</span></td>
<td> </td>
<td><span href="#/AttackonPearlHarbor_ch803#cha16" title="Link target outside of Sample">AP Bomb Hits: Claimed and Actual</span></td>
</tr>
<tr valign="top">
<td></td></tr>
<tr valign="top">
<td><span href="#/AttackonPearlHarbor_ch805#cha17" title="Link target outside of Sample">17.</span></td>
<td> </td>
<td><span href="#/AttackonPearlHarbor_ch805#cha17" title="Link target outside of Sample">GP Bombs: Hits Claimed and Attacks Claimed</span></td>
</tr>
<tr valign="top">
<td></td></tr>
<tr valign="top">
<td><span href="#/AttackonPearlHarbor_ch807#cha18" title="Link target outside of Sample">18.</span></td>
<td> </td>
<td><span href="#/AttackonPearlHarbor_ch807#cha18" title="Link target outside of Sample">GP Bombs: Hits Claimed and Actual Hits</span></td>
</tr>
<tr valign="top">
<td></td></tr>
<tr valign="top">
<td><span href="#/AttackonPearlHarbor_ch809#cha19" title="Link target outside of Sample">19.</span></td>
<td> </td>
<td><span href="#/AttackonPearlHarbor_ch809#cha19" title="Link target outside of Sample">GP Bombs: Hits Claimed and US Records of Attacks</span></td>
</tr>
<tr valign="top">
<td></td></tr>
<tr valign="top">
<td><span href="#/AttackonPearlHarbor_ch1101#cha20" title="Link target outside of Sample">20.</span></td>
<td> </td>
<td><span href="#/AttackonPearlHarbor_ch1101#cha20" title="Link target outside of Sample">The Fifth Midget Submarine: Event Flow Chart</span></td>
</tr>
</tbody></table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// AttackonPearlHarbor_chartsanddiagrams.vue?30f6836c